module.exports = __webpack_public_path__ + "static/media/MHRP39N0015.4f80bb40.svg";